import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App';
import { HydratingPrerender, type PrerenderPayload } from './prerender/PrerenderDocument';
import './styles.css';
import './refinements.css';

declare global { interface Window { __EB_PRERENDER__?: PrerenderPayload; __EB_HOME__?: boolean } }

const root = document.getElementById('root');
if (!root) throw new Error('Missing application root');
if (window.__EB_PRERENDER__) {
  hydrateRoot(root, <StrictMode><HydratingPrerender payload={window.__EB_PRERENDER__} /></StrictMode>);
} else if (window.__EB_HOME__) {
  hydrateRoot(root, <StrictMode><App /></StrictMode>);
} else {
  createRoot(root).render(<StrictMode><App /></StrictMode>);
}
